/**
 * Shared utilities for PiP feature used by external_api.js.
 *
 * IMPORTANT: Keep this file minimal with no heavy dependencies.
 * It's bundled into external_api.min.js and we want to keep that bundle slim.
 * Only import lightweight modules here.
 */
/**
 * Checks if current environment is Electron.
 * Inline check to avoid importing BrowserDetection and its ua-parser dependency.
 *
 * @returns {boolean} - True if running in Electron.
 */
function isElectron() {
    return navigator.userAgent.includes('Electron');
}
/**
 * 当前环境是否支持浏览器原生画中画 API。
 * 部分 WebView 未暴露 pictureInPictureEnabled，但仍实现了 requestPictureInPicture。
 *
 * @returns {boolean}
 */
function isBrowserPiPSupported() {
    const doc = typeof document === 'undefined' ? undefined : document;
    if (!doc) {
        return false;
    }
    const pipFlag = doc.pictureInPictureEnabled;
    if (typeof pipFlag === 'boolean') {
        return pipFlag;
    }
    try {
        const probe = doc.createElement('video');
        return typeof probe.requestPictureInPicture === 'function';
    }
    catch {
        return false;
    }
}
/**
 * Checks if PiP is enabled based on config and environment.
 * Electron 与支持原生 PiP 的电脑/手机浏览器均可启用（可用 config.pip.disabled 关闭）。
 *
 * @param {Object} pipConfig - The pip config object.
 * @returns {boolean} - True if PiP is enabled.
 */
export function isPiPEnabled(pipConfig) {
    if (pipConfig?.disabled) {
        return false;
    }
    if (isElectron()) {
        return true;
    }
    return isBrowserPiPSupported();
}
